<template>
    <div>
        <van-nav-bar
        title="会员中心"
        />

        <div class="card">
           <van-image src="https://public.qiniu.xcims.com/WeChatVipCard.png" height="13rem" />
            <div class="card-title-one">VIP
            <span class="card-title-two">贵宾卡</span>
            </div>
            <div class="card-title-three">
            <span>{{vipinfo.shop}}</span>
            </div>
            <div class="card-subtitle-one" @click="tovip()">
            <van-icon name="setting" size="35"/>
            </div>
            <div class="card-subtitle-two">
            {{vipinfo.name}}
            </div>
            <div class="card-subtitle-three">
            NO.{{vipinfo.id}}
            </div>
        </div>

        <van-row style="text-align: center; margin-top:15px;">
            <van-col span="8" >
                <div class="membershipGrade-size">等级</div>
                <div class="membershipIntegral">{{vipinfo.grade}}</div>
            </van-col>
            <van-col span="8" >
                <div class="membershipGrade-size">积分</div>
                <div class="membershipIntegral">{{vipinfo.available_score}}</div>
            </van-col>
            <van-col span="8" >
                <div class="membershipGrade-size">余额</div>
                <div class="membershipIntegral">{{vipinfo.amount_available}}</div>
            </van-col>
        </van-row>
        <div class="verticalLine"></div>
        <div class="verticalLine-one"></div>

        <van-grid style="margin-top:15px;" :column-num="3">
          <van-grid-item v-for="item in menu" :key="item.title" @click="redirect(item.page)">
            <i :class="item.icon " slot="icon" :style="item.style"></i>
            <span slot="text" style="color:#808080">{{item.title}}</span>
          </van-grid-item>
        </van-grid>

    </div>
</template>

<script>
import { NavBar, Col, Row, Grid, GridItem, Image as VanImage, Icon, Dialog } from 'vant';
import { VipInfoApi } from '@/api/vip'
import { authURL } from '@/utils/auth'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [VanImage.name]: VanImage,
        [Col.name]: Col,
        [Row.name]: Row,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Icon.name]: Icon,
        [Dialog.name]: Dialog
    },
    data() {
        return {
          menu : [
          {
            title: '我的车辆',
            page: '/nt/user/mycars',
            class: 'color-four',
            style: 'color: #99d144; font-size:70px;',
            icon: 'icomoon icon-booking'
          },
          // {
          //   title: '办卡套餐',
          //   page: '/nt/user/cardpackage',
          //   class: 'color-four',
          //   style: 'color: #99d144; font-size:70px;',
          //   icon: 'icomoon icon-recharge'
          // },
          {
            title: '消费记录',
            page: '/nt/user/consumptionrecords',
            class: 'color-one',
            style: 'color: #31d390; font-size:70px;',
            icon: 'icomoon icon-record'
          },
          {
            title: '套餐卡',
            page: '/nt/user/dinnercard',
            class: 'color-two',
            style: 'color: #26b8ff; font-size:70px;',
            icon: 'icomoon icon-beauty'
          },
          {
            title: '储值卡',
            page: '/nt/user/storedcard',
            class: 'color-three',
            style: 'color: #fc8734; font-size:70px;',
            icon: 'icomoon icon-stored'
          },
          {
            title: '优惠卷',
            page: '/nt/user/coupons',
            class: 'color-five',
            style: 'color: #689ef3; font-size:70px;',
            icon: 'icomoon icon-coupon'
          },
          {
            title: '兑换券',
            page: '/nt/user/vouchers',
            class: 'color-six',
            style: 'color: #8d7bff; font-size:70px;',
            icon: 'icomoon icon-redemption'
          },
          // {
          //   title: '我的保养',
          //   page: '/nt/user/maintenance',
          //   class: 'color-seven',
          //    style: 'color: #26b8ff; font-size:70px;',
          //   icon: 'icomoon icon-lottery'
          // },
          {
            title: '预约服务',
            page: '/nt/user/booking',
            class: 'color-eight',
             style: 'color: #fc8734; font-size:70px;',
            icon: 'icomoon icon-booking'
          },
          {
            title: '投诉建议',
            page: '/nt/user/complaint',
            class: 'color-nine',
            style: 'color: #51d03a; font-size:70px;',
            icon: 'icomoon icon-complaint'
          },
          {
            title: '商城订单',
            page: '/nt/usedcarorders',
            class: 'color-tem',
            style: 'color: #51d03a; font-size:70px;',
            icon: 'icomoon icon-complaint'
          },
          // {
          //   title: '商城订单',
          //   page: '/nt/repair/directsellslist',
          //   class: 'color-tem',
          //   style: 'color: #51d03a; font-size:70px;',
          //   icon: 'icomoon icon-complaint'
          // },
          // {
          //   title: '维修服务',
          //   page: '/nt/repair',
          //   class: 'color-four',
          //   style: 'color: #99d144; font-size:70px;',
          //   icon: 'icomoon icon-recharge'
          // },
        ],
        vipinfo: {
            id: 0,
            shop: '',
            name: '',
            grade: '',
            available_score: 0,
            stored_card: false,
            amount_available: 0,
        }
      }
    },
    mounted(){
      this.getVipInfo()
    },
    methods: {
      tovip(){
        this.$router.push('/nt/user/vipinfo')
      },
      redirect(page){
        this.$router.push(page)
      },
      getVipInfo(){
        var that = this
        that.axios.get(VipInfoApi).then((ret) => {
          if (ret.flag) {
            ret = ret.details
            that.vipinfo = {
              id: ret.id?ret.id:0,
              shop: ret.shop?ret.shop:'',
              name: ret.name?ret.name:'',
              grade: ret.grade?ret.grade:'',
              available_score: ret.available_score?ret.available_score:0,
              stored_card: ret.stored_card?ret.stored_card:false,
              amount_available: ret.amount_available?ret.amount_available:0,
            }
          } else {
            if (ret.details) {
              const url = authURL(ret.details)
              console.log(url)
              this.$router.push(url)
            } else {
              toErrorPage(this,'',ret.info,null)
              // Dialog.alert({
              //   title: '警告',
              //   message: ret.info
              // })
            }
          }
        })
      }
    }
}
</script>

<style lang="less" scoped>
  .card {
    position: relative;
  }
  .card-title-one {
    position: absolute;
    top: 10%;
    font-size: 35px;
    font-weight: bold;
    color: #ffffff;
    margin-left: 3%;
  }
  .card-title-two {
    position: absolute;
    top: 30%;
    font-size: 16px;
    left: 90%;
    width: 100%;
    color: #ffffff;
    margin-left: 10%;
  }
  .card-title-three {
    position: absolute;
    top: 30%;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    margin-left: 3%;
  }
  // .card-subtitle-one {
  //   font-size: 16px;
  //   position: absolute;
  //   top: 70%;
  //   font-weight: bold;
  //   color: #000000;
  // }
  .card-subtitle-one {
    font-size: 20px;
    position: absolute;
    top: 10%;
    width: 95%;
    font-weight: bold;
    color: #ffffff;
    text-align: right;
  }
  .card-subtitle-two {
    font-size: 20px;
    position: absolute;
    top: 65%;
    width: 95%;
    font-weight: bold;
    color: #ffffff;
    text-align: right;
  }
  .card-subtitle-three {
    font-size: 18px;
    position: absolute;
    top: 80%;
    width: 95%;
    color: #ffffff;
    text-align: right;
  }
  .card-title-button {
    top: 100%;
    width: 100%;
    font-size: 17px;
    color: #adadad;
  }
  .membershipGrade-size {
    font-size: 15px;
  }
  .membershipIntegral {
    font-size: 20px;
    color: #fc8734;
  }
  .verticalLine {
    float: left;
    width: 1px;
    height: 50px;
    margin-top: -35pt;
    margin-left: 33%;
    background: #a7a7a7;
  }
  .verticalLine-one {
    float: left;
    width: 1px;
    height: 50px;
    margin-top: -38pt;
    margin-left: 67%;
    background: #a7a7a7;
  }
  .picture {
    width: 100%;
  }
  .color-one {
    color: #31d390;
  }
  .color-two {
    color: #26b8ff;
  }
  .color-three {
    color: #fc8734;
  }
  .color-four {
    color: #99d144;
  }
  .color-five {
    color: #689ef3;
  }
  .color-six {
    color: #8d7bff;
  }
  .color-seven {
    color: #26b8ff;
  }
  .color-eight {
    color: #fc8734;
  }
  .color-nine {
    color: #51d03a;
  }
  ion-icon {
    font-size: 55pt;
  }
</style>